import React, { useState, useEffect } from 'react';
import PropTypes, { number, string, shape, func, arrayOf } from 'prop-types';

import { TYPES } from 'envs/core.js';
import { SCPactometroCheck } from './style.js';
import CheckImg from '../../assets/check.png';
import { customAcronym, customColor, getSite } from '../../constants/sites.js';

const PactometroCheck = ({
  data,
  onChange,
  selecteds = [],
  cols,
  type,
  pactometroType
}) => {
  const [selectedsId, setSelectedsId] = useState(selecteds);

  const onchange = id => {
    let selecteds = [...selectedsId];

    if (selectedsId.some(select => select === id)) {
      selecteds = selecteds.filter(item => item !== id);
    } else {
      selecteds = [...selecteds, id];
    }

    setSelectedsId(selecteds);

    onChange(selecteds);
  };

  useEffect(() => {
    setSelectedsId(selecteds);
  }, [selecteds]);
  const getLabel = items => {
    const labelMunicipal = items > 1 ? `${items} concejales` : '1 concejal';
    const labelAutonomic = items > 1 ? `${items} escaños` : '1 escaño';
    return type === TYPES.MUNICIPAL ? labelMunicipal : labelAutonomic;
  };

  return (
    <SCPactometroCheck cols={cols} labelCheckImage={CheckImg}>
      {data &&
        data.map(item => (
          <div
            key={JSON.stringify(item)}
            className="row-pactometro"
            role="presentation"
          >
            <input
              id={`${pactometroType}-${item.id}`}
              type="checkbox"
              onChange={() => {}}
            />
            {/* eslint-disable-next-line */}
            <label
              onClick={() => onchange(item.id)}
              htmlFor={`${pactometroType}-${item.id}`}
              style={{
                borderLeft: `11px solid ${customColor(item, getSite())} `
              }}
            >
              <span>{customAcronym(item, getSite())}</span>
              <p>
                {' '}
                {/* ({item.seats} escaños - {item.votesPercent}% votos) */}
                {/* {item.seats > 1 ? `${item.seats} escaños` : '1 escaño'} */}
                {getLabel(item.seats)}
              </p>
            </label>
          </div>
        ))}
    </SCPactometroCheck>
  );
};

PactometroCheck.propTypes = {
  data: arrayOf(
    shape({
      partyAcronym: string.isRequired,
      seats: number.isRequired,
      partyColor: string.isRequired,
      votes: number.isRequired,
      id: number.isRequired
    })
  ).isRequired,
  onChange: func.isRequired,
  cols: number,
  pactometroType: PropTypes.oneOf(['simple', 'noSimple', 'ranking'])
};

PactometroCheck.defaultProps = {
  pactometroType: 'simple'
};

export default PactometroCheck;
